var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowSoils(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 42,
    viewBox: "0 0 95 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#94C11F",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M81.089 28.638L89.089 28.638 89.089 36.03",
    transform: "translate(-989 -228) translate(990.64 229.5) scale(1 -1) rotate(-32 -27.674 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31.656c22.091 3.875 47.287 2.819 59.36-2.235C73.642 23.443 82.475 13.636 85.86 0",
    transform: "translate(-989 -228) translate(990.64 229.5) matrix(1 0 0 -1 0 34)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSoils);
export default __webpack_public_path__ + "static/media/arrowSoils.a192fe84.svg";
export { ForwardRef as ReactComponent };